import { useCallback, useEffect, useRef } from 'react'
import { useAppDispatch } from '../store/hooks'
import { setNotificationsCounts } from '../features/security/security.slice'
import useAxiosPrivate from './useAxiosPrivate'

const POLL_INTERVAL_MS = 30_000

const useNotificationPolling = () => {
    const dispatch = useAppDispatch()
    const axiosPrivate = useAxiosPrivate()
    const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null)

    const fetchCounts = useCallback(async () => {
        try {
            const response = await axiosPrivate.get(
                '/processes/notifications/counts'
            )
            if (response.data?.success && response.data?.data?.notifications) {
                dispatch(
                    setNotificationsCounts({
                        totalCount:
                            response.data.data.notifications.totalCount ?? 0,
                        unreadCount:
                            response.data.data.notifications.unreadCount ?? 0,
                    })
                )
            }
        } catch {
            // Silent fail — polling should not disrupt UX
        }
    }, [axiosPrivate, dispatch])

    useEffect(() => {
        fetchCounts()

        intervalRef.current = setInterval(fetchCounts, POLL_INTERVAL_MS)

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current)
            }
        }
    }, [fetchCounts])
}

export default useNotificationPolling
